
<div class="container">
  <div *ngIf="!isPJOuCpfComOutorga()" style="color: red;" align="center" >
    Atenção! Para certificados de pessoa física é necessário entrar com o 
    outorgante para cadastrar ou consultar máquina
    <br/>
  </div>
  <div class="row justify-content-md-center">
    <div class="col col-lg-6">
      <mat-card class="apresentacao">
        <mat-card-title>Através do Cadastro de Máquina você poderá:</mat-card-title>
        <mat-card-content >
          <mat-list >
            <mat-list-item class="links"><img class="img-fluid" src="assets/icons/check.png"  width="16px"/>  
              <div style="padding-left: 4px;">Cadastrar Máquina</div>
            </mat-list-item>
            <mat-list-item class="links"><img class="img-fluid" src="assets/icons/check.png"  width="16px"/>  
              <div style="padding-left: 4px;">Alterar Máquina</div>
            </mat-list-item>
            <mat-list-item class="links"><img class="img-fluid" src="assets/icons/check.png"  width="16px"/>  
              <div style="padding-left: 4px;">Consultar Máquina</div>
            </mat-list-item>
            <mat-list-item class="links"> <img class="img-fluid" src="assets/icons/check.png"  width="16px"/>  
              <div style="padding-left: 4px;">Consultar Histórico</div>
            </mat-list-item>
            <mat-list-item class="links"><img class="img-fluid" src="assets/icons/check.png"  width="16px"/>  
              <div style="padding-left: 4px;">Bloquear Máquina</div>
            </mat-list-item>
          </mat-list>
        </mat-card-content>
      </mat-card>
    </div>  
  </div>
 </div>
